// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Styles pour le support RTL (Right-to-Left) */

/* Configuration de base pour RTL */
.rtl-layout {
    direction: rtl !important;
    text-align: right !important;
}

.ltr-layout {
    direction: ltr !important;
    text-align: left !important;
}

/* Styles pour les marges et paddings en RTL */
.rtl-layout .margin-left {
    margin-left: 0 !important;
    margin-right: var(--margin-value, 1rem) !important;
}

.rtl-layout .margin-right {
    margin-right: 0 !important;
    margin-left: var(--margin-value, 1rem) !important;
}

.rtl-layout .padding-left {
    padding-left: 0 !important;
    padding-right: var(--padding-value, 1rem) !important;
}

.rtl-layout .padding-right {
    padding-right: 0 !important;
    padding-left: var(--padding-value, 1rem) !important;
}

/* Styles pour les positions (left/right) en RTL */
.rtl-layout .left {
    left: auto !important;
    right: var(--position-value, 0) !important;
}

.rtl-layout .right {
    right: auto !important;
    left: var(--position-value, 0) !important;
}

/* Styles pour flexbox en RTL */
.rtl-layout .flex-row {
    flex-direction: row-reverse !important;
}

.rtl-layout .justify-start {
    justify-content: flex-end !important;
}

.rtl-layout .justify-end {
    justify-content: flex-start !important;
}

/* Styles pour les éléments de formulaire en RTL */
.rtl-layout input[type="text"],
.rtl-layout input[type="email"],
.rtl-layout input[type="password"],
.rtl-layout textarea,
.rtl-layout select {
    text-align: right !important;
}

.rtl-layout input[type="checkbox"],
.rtl-layout input[type="radio"] {
    margin-right: 0 !important;
    margin-left: 0.5rem !important;
}

/* Styles pour les boutons en RTL */
.rtl-layout button {
    text-align: center !important;
}

/* Styles pour les icônes en RTL */
.rtl-layout .icon-arrow-left::before {
    content: "→" !important;
}

.rtl-layout .icon-arrow-right::before {
    content: "←" !important;
}

/* Styles pour les listes en RTL */
.rtl-layout ul,
.rtl-layout ol {
    padding-right: 1.5rem !important;
    padding-left: 0 !important;
}

/* Styles pour les tableaux en RTL */
.rtl-layout table {
    direction: rtl !important;
}

.rtl-layout th,
.rtl-layout td {
    text-align: right !important;
}

/* Styles pour les menus de navigation en RTL */
.rtl-layout .nav-menu {
    direction: rtl !important;
}

.rtl-layout .nav-menu li {
    float: right !important;
}

/* Styles spéciaux pour les nombres et dates en RTL */
.rtl-layout .number,
.rtl-layout .date,
.rtl-layout .time {
    direction: ltr !important;
    text-align: left !important;
    display: inline-block;
}

/* Styles pour les tooltips en RTL */
.rtl-layout .tooltip {
    direction: rtl !important;
}

/* Animation pour transition fluide */
* {
    transition: margin 0.2s ease, padding 0.2s ease, text-align 0.2s ease;
}

/* Classes utilitaires pour forcer la direction */
.force-ltr {
    direction: ltr !important;
    text-align: left !important;
}

.force-rtl {
    direction: rtl !important;
    text-align: right !important;
}

/* Styles pour les éléments qui doivent toujours rester LTR */
.rtl-layout .always-ltr {
    direction: ltr !important;
    text-align: left !important;
}

/* Exemples: URLs, emails, code, etc. */
.rtl-layout .url,
.rtl-layout .email,
.rtl-layout .code,
.rtl-layout pre,
.rtl-layout code {
    direction: ltr !important;
    text-align: left !important;
}

/* Styles pour les sidebar et menus latéraux */
.rtl-layout .sidebar {
    right: 0 !important;
    left: auto !important;
}

.rtl-layout .sidebar-left {
    right: 0 !important;
    left: auto !important;
}

.rtl-layout .sidebar-right {
    left: 0 !important;
    right: auto !important;
}

/* Media queries pour responsive RTL */
@media (max-width: 768px) {
    .rtl-layout .mobile-text {
        text-align: right !important;
    }
}

/* Support pour les frameworks CSS populaires (Bootstrap, etc.) */
.rtl-layout .text-left {
    text-align: right !important;
}

.rtl-layout .text-right {
    text-align: left !important;
}

.rtl-layout .float-left {
    float: right !important;
}

.rtl-layout .float-right {
    float: left !important;
}

.rtl-layout .pull-left {
    float: right !important;
}

.rtl-layout .pull-right {
    float: left !important;
}`, "",{"version":3,"sources":["webpack://./src/styles/rtl-support.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C,mCAAmC;AACnC;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA,8CAA8C;AAC9C;IACI,yBAAyB;IACzB,kDAAkD;AACtD;;AAEA;IACI,0BAA0B;IAC1B,iDAAiD;AACrD;;AAEA;IACI,0BAA0B;IAC1B,oDAAoD;AACxD;;AAEA;IACI,2BAA2B;IAC3B,mDAAmD;AACvD;;AAEA,kDAAkD;AAClD;IACI,qBAAqB;IACrB,0CAA0C;AAC9C;;AAEA;IACI,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA,+BAA+B;AAC/B;IACI,sCAAsC;AAC1C;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA,kDAAkD;AAClD;;;;;IAKI,4BAA4B;AAChC;;AAEA;;IAEI,0BAA0B;IAC1B,8BAA8B;AAClC;;AAEA,mCAAmC;AACnC;IACI,6BAA6B;AACjC;;AAEA,kCAAkC;AAClC;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,kCAAkC;AAClC;;IAEI,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA,oCAAoC;AACpC;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,4BAA4B;AAChC;;AAEA,+CAA+C;AAC/C;IACI,yBAAyB;AAC7B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA,qDAAqD;AACrD;;;IAGI,yBAAyB;IACzB,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA,oCAAoC;AACpC;IACI,yBAAyB;AAC7B;;AAEA,qCAAqC;AACrC;IACI,qEAAqE;AACzE;;AAEA,iDAAiD;AACjD;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA,6DAA6D;AAC7D;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA,uCAAuC;AACvC;;;;;IAKI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA,8CAA8C;AAC9C;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA,sCAAsC;AACtC;IACI;QACI,4BAA4B;IAChC;AACJ;;AAEA,iEAAiE;AACjE;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;AAC1B","sourcesContent":["/* Styles pour le support RTL (Right-to-Left) */\n\n/* Configuration de base pour RTL */\n.rtl-layout {\n    direction: rtl !important;\n    text-align: right !important;\n}\n\n.ltr-layout {\n    direction: ltr !important;\n    text-align: left !important;\n}\n\n/* Styles pour les marges et paddings en RTL */\n.rtl-layout .margin-left {\n    margin-left: 0 !important;\n    margin-right: var(--margin-value, 1rem) !important;\n}\n\n.rtl-layout .margin-right {\n    margin-right: 0 !important;\n    margin-left: var(--margin-value, 1rem) !important;\n}\n\n.rtl-layout .padding-left {\n    padding-left: 0 !important;\n    padding-right: var(--padding-value, 1rem) !important;\n}\n\n.rtl-layout .padding-right {\n    padding-right: 0 !important;\n    padding-left: var(--padding-value, 1rem) !important;\n}\n\n/* Styles pour les positions (left/right) en RTL */\n.rtl-layout .left {\n    left: auto !important;\n    right: var(--position-value, 0) !important;\n}\n\n.rtl-layout .right {\n    right: auto !important;\n    left: var(--position-value, 0) !important;\n}\n\n/* Styles pour flexbox en RTL */\n.rtl-layout .flex-row {\n    flex-direction: row-reverse !important;\n}\n\n.rtl-layout .justify-start {\n    justify-content: flex-end !important;\n}\n\n.rtl-layout .justify-end {\n    justify-content: flex-start !important;\n}\n\n/* Styles pour les éléments de formulaire en RTL */\n.rtl-layout input[type=\"text\"],\n.rtl-layout input[type=\"email\"],\n.rtl-layout input[type=\"password\"],\n.rtl-layout textarea,\n.rtl-layout select {\n    text-align: right !important;\n}\n\n.rtl-layout input[type=\"checkbox\"],\n.rtl-layout input[type=\"radio\"] {\n    margin-right: 0 !important;\n    margin-left: 0.5rem !important;\n}\n\n/* Styles pour les boutons en RTL */\n.rtl-layout button {\n    text-align: center !important;\n}\n\n/* Styles pour les icônes en RTL */\n.rtl-layout .icon-arrow-left::before {\n    content: \"→\" !important;\n}\n\n.rtl-layout .icon-arrow-right::before {\n    content: \"←\" !important;\n}\n\n/* Styles pour les listes en RTL */\n.rtl-layout ul,\n.rtl-layout ol {\n    padding-right: 1.5rem !important;\n    padding-left: 0 !important;\n}\n\n/* Styles pour les tableaux en RTL */\n.rtl-layout table {\n    direction: rtl !important;\n}\n\n.rtl-layout th,\n.rtl-layout td {\n    text-align: right !important;\n}\n\n/* Styles pour les menus de navigation en RTL */\n.rtl-layout .nav-menu {\n    direction: rtl !important;\n}\n\n.rtl-layout .nav-menu li {\n    float: right !important;\n}\n\n/* Styles spéciaux pour les nombres et dates en RTL */\n.rtl-layout .number,\n.rtl-layout .date,\n.rtl-layout .time {\n    direction: ltr !important;\n    text-align: left !important;\n    display: inline-block;\n}\n\n/* Styles pour les tooltips en RTL */\n.rtl-layout .tooltip {\n    direction: rtl !important;\n}\n\n/* Animation pour transition fluide */\n* {\n    transition: margin 0.2s ease, padding 0.2s ease, text-align 0.2s ease;\n}\n\n/* Classes utilitaires pour forcer la direction */\n.force-ltr {\n    direction: ltr !important;\n    text-align: left !important;\n}\n\n.force-rtl {\n    direction: rtl !important;\n    text-align: right !important;\n}\n\n/* Styles pour les éléments qui doivent toujours rester LTR */\n.rtl-layout .always-ltr {\n    direction: ltr !important;\n    text-align: left !important;\n}\n\n/* Exemples: URLs, emails, code, etc. */\n.rtl-layout .url,\n.rtl-layout .email,\n.rtl-layout .code,\n.rtl-layout pre,\n.rtl-layout code {\n    direction: ltr !important;\n    text-align: left !important;\n}\n\n/* Styles pour les sidebar et menus latéraux */\n.rtl-layout .sidebar {\n    right: 0 !important;\n    left: auto !important;\n}\n\n.rtl-layout .sidebar-left {\n    right: 0 !important;\n    left: auto !important;\n}\n\n.rtl-layout .sidebar-right {\n    left: 0 !important;\n    right: auto !important;\n}\n\n/* Media queries pour responsive RTL */\n@media (max-width: 768px) {\n    .rtl-layout .mobile-text {\n        text-align: right !important;\n    }\n}\n\n/* Support pour les frameworks CSS populaires (Bootstrap, etc.) */\n.rtl-layout .text-left {\n    text-align: right !important;\n}\n\n.rtl-layout .text-right {\n    text-align: left !important;\n}\n\n.rtl-layout .float-left {\n    float: right !important;\n}\n\n.rtl-layout .float-right {\n    float: left !important;\n}\n\n.rtl-layout .pull-left {\n    float: right !important;\n}\n\n.rtl-layout .pull-right {\n    float: left !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
